

import React, { useState } from 'react';
/*import { BookOpen, DollarSign, Users, FileSpreadsheet, ShieldCheck, Smartphone, Menu, X, ChevronRight } from 'lucide-react';*/
import { BookOpen, DollarSign, Users, FileSpreadsheet, ShieldCheck, Smartphone, Menu, X, ChevronRight, Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom'; // <-- AGREGAR ESTA LÍNEA

const LandingPage = () => {
  // Estado para controlar el menú móvil
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-800">
      
      {/* 1. NAVBAR MODERNO Y RESPONSIVO */}
      {/* Usamos bg-white/90 y backdrop-blur para un efecto cristal elegante */}
      <nav className="bg-white/90 backdrop-blur-md border-b border-slate-200 sticky top-0 z-50 transition-all duration-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-20 items-center">
            
            {/* Logo de la Empresa (Aquí puedes poner tu logo .png) */}
            <div className="flex items-center cursor-pointer">
              <div className="bg-blue-600 p-2 rounded-lg">
                <BookOpen className="h-6 w-6 text-white" />
              </div>
              <span className="ml-3 text-2xl font-black bg-clip-text text-transparent bg-gradient-to-r from-blue-700 to-blue-500 tracking-tight">
                EMD EduSaaS
              </span>
            </div>

           {/* Enlaces de Escritorio (Ocultos en móviles) */}
            <div className="hidden md:flex space-x-2 items-center">
              <a href="#caracteristicas" className="text-sm font-semibold text-slate-600 px-4 py-2 rounded-lg hover:text-blue-600 hover:bg-blue-50 active:bg-blue-100 transition-all duration-200">
                Características
              </a>
              <a href="#modulos" className="text-sm font-semibold text-slate-600 px-4 py-2 rounded-lg hover:text-blue-600 hover:bg-blue-50 active:bg-blue-100 transition-all duration-200">
                Módulos SIAGIE
              </a>
              <a href="#contacto" className="text-sm font-semibold text-slate-600 px-4 py-2 rounded-lg hover:text-blue-600 hover:bg-blue-50 active:bg-blue-100 transition-all duration-200">
                Contacto
              </a>
            </div>

            {/* Botón de Acción de Escritorio */}
            <div className="hidden md:flex items-center space-x-4">
              <a href="#login" className="text-sm font-bold text-blue-600 hover:text-blue-800 transition-colors">
                Iniciar Sesión
              </a>

              
              <Link to="/login"  className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium transition-colors">
                Ingresar al Sistema
                </Link>
              

              <button className="bg-blue-600 text-white px-6 py-2.5 rounded-full font-semibold text-sm hover:bg-blue-700 hover:shadow-lg hover:shadow-blue-500/30 transition-all flex items-center gap-2">
                Solicitar Demo <ChevronRight className="w-4 h-4" />
              </button>
            </div>

            {/* Botón Menú Hamburguesa (Solo visible en móviles) */}
            <div className="md:hidden flex items-center">
              <button 
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-slate-600 hover:text-blue-600 focus:outline-none p-2"
              >
                {isMenuOpen ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
              </button>
            </div>
          </div>
        </div>

        {/* Menú Desplegable Móvil */}
        <div className={`md:hidden absolute w-full bg-white border-b border-slate-200 shadow-xl transition-all duration-300 ease-in-out ${isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
          <div className="px-4 pt-2 pb-6 space-y-2 flex flex-col">
            <a href="#caracteristicas" className="block px-3 py-3 rounded-md text-base font-medium text-slate-700 hover:text-blue-600 hover:bg-blue-50 transition-colors">Características</a>
            <a href="#modulos" className="block px-3 py-3 rounded-md text-base font-medium text-slate-700 hover:text-blue-600 hover:bg-blue-50 transition-colors">Módulos SIAGIE</a>
            <a href="#contacto" className="block px-3 py-3 rounded-md text-base font-medium text-slate-700 hover:text-blue-600 hover:bg-blue-50 transition-colors">Contacto</a>
            
            <div className="border-t border-slate-100 pt-4 mt-2 flex flex-col gap-3">
              <button className="w-full text-center px-4 py-3 border border-blue-600 text-blue-600 rounded-lg font-bold hover:bg-blue-50 transition-colors">
                Iniciar Sesión
              </button>
              <button className="w-full text-center px-4 py-3 bg-blue-600 text-white rounded-lg font-bold hover:bg-blue-700 shadow-md transition-colors">
                Solicitar Demo
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section (Aún con el diseño básico, lo mejoraremos en el siguiente paso) */}
      {/* 2. HERO SECTION MODERNA */}
      {/* 2. HERO SECTION (DARK MODE - ALTO CONTRASTE) */}
      <section className="relative bg-slate-900 pt-24 pb-32 overflow-hidden border-b border-slate-800">
        {/* Glows de fondo más intensos para neuromarketing visual */}
        <div className="absolute top-0 left-1/2 w-full -translate-x-1/2 h-full overflow-hidden -z-10 pointer-events-none">
          <div className="absolute top-[-20%] left-[10%] w-[500px] h-[500px] bg-blue-600/20 rounded-full blur-[100px]"></div>
          <div className="absolute top-[20%] right-[0%] w-[400px] h-[400px] bg-cyan-500/20 rounded-full blur-[100px]"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative text-center">
          
          {/* Badge de Promoción (Adaptado a fondo oscuro) */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800/80 border border-slate-700 text-blue-400 text-sm font-semibold mb-8 backdrop-blur-sm">
            <span className="flex h-2 w-2 rounded-full bg-blue-500 animate-pulse"></span>
            Campaña de lanzamiento: 50% de descuento en la implementación hasta el 28 de febrero de 2026
          </div>

          {/* Título Principal (Blanco para contraste absoluto) */}
          <h1 className="text-5xl md:text-7xl font-extrabold text-white tracking-tight mb-6 leading-tight">
            El control total de tu institución <br className="hidden md:block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300 drop-shadow-sm">
              en una sola plataforma
            </span>
          </h1>
          
          {/* Subtítulo */}
          <p className="text-lg md:text-xl text-slate-300 max-w-2xl mx-auto mb-10 leading-relaxed font-light">
            Automatiza matrículas, gestiona pagos exactos y genera reportes compatibles con el SIAGIE en segundos. Diseñado para la eficiencia.
          </p>
          
          {/* Botones de Acción */}
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-20">
            <button className="bg-blue-500 text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-blue-400 shadow-[0_0_20px_rgba(59,130,246,0.4)] transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2">
              Prueba gratuita de 14 días <ChevronRight className="w-5 h-5" />
            </button>
            <button className="bg-slate-800 text-white border border-slate-600 px-8 py-4 rounded-xl font-bold text-lg hover:bg-slate-700 hover:border-slate-500 transition-all flex items-center justify-center">
              Agendar demostración
            </button>
          </div>

          {/* Mockup del Sistema (Ajustado para brillar sobre el fondo oscuro) */}
          <div className="relative mx-auto max-w-5xl">
            <div className="rounded-t-2xl border border-slate-700 bg-slate-800/50 p-2 shadow-2xl shadow-black/50 backdrop-blur-xl">
              <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden flex flex-col">
                <div className="bg-slate-100 border-b border-slate-200 px-4 py-3 flex items-center gap-2">
                  <div className="flex gap-1.5">
                    <div className="w-3 h-3 rounded-full bg-red-400"></div>
                    <div className="w-3 h-3 rounded-full bg-amber-400"></div>
                    <div className="w-3 h-3 rounded-full bg-green-400"></div>
                  </div>
                  <div className="ml-4 bg-white border border-slate-200 rounded-md text-xs text-slate-500 px-24 py-1 flex-1 text-center font-mono shadow-sm">
                    app.emdingenieros.com/dashboard
                  </div>
                </div>
                {/* Cuerpo del mockup */}
                <div className="p-8 flex gap-6">
                  <div className="w-48 hidden md:flex flex-col gap-3">
                    <div className="h-8 bg-slate-100 rounded-md w-full"></div>
                    <div className="h-8 bg-blue-50 border border-blue-100 rounded-md w-full"></div>
                    <div className="h-8 bg-slate-100 rounded-md w-3/4"></div>
                  </div>
                  <div className="flex-1 flex flex-col gap-4">
                    <div className="flex gap-4">
                      <div className="h-24 bg-indigo-50 rounded-xl flex-1 border border-indigo-100"></div>
                      <div className="h-24 bg-emerald-50 rounded-xl flex-1 border border-emerald-100"></div>
                      <div className="h-24 bg-amber-50 rounded-xl flex-1 border border-amber-100"></div>
                    </div>
                    <div className="h-64 bg-slate-50 rounded-xl border border-slate-100 w-full mt-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* El resto del código de Módulos (se mantiene igual por ahora para no abrumar) */}
      {/* 3. SECCIÓN DE MÓDULOS (CARACTERÍSTICAS) */}
     {/* 3. SECCIÓN DE MÓDULOS (CON ACCENT BORDERS Y MAYOR CONTRASTE) */}
      <section id="modulos" className="py-24 bg-slate-50 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-sm font-bold tracking-wide text-blue-600 uppercase mb-3">
              Potencia tu Gestión
            </h2>
            <h3 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4">
              Módulos diseñados para la eficiencia
            </h3>
            <p className="text-lg text-slate-600">
              Automatiza procesos tediosos y dale a tu equipo las herramientas que necesitan.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            
            {/* Tarjeta 1: Matrículas (Azul) */}
            <div className="group bg-white border border-slate-200 border-t-[6px] border-t-blue-500 p-8 rounded-b-2xl rounded-t-md shadow-md hover:shadow-2xl hover:shadow-blue-500/10 hover:-translate-y-1 transition-all duration-300">
              <div className="w-14 h-14 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300">
                <Users className="h-7 w-7" />
              </div>
              <h4 className="text-xl font-bold text-slate-900 mb-3">Sistema de Matrículas</h4>
              <p className="text-slate-600 leading-relaxed">
                Control completo de vacantes, registro de alumnos y apoderados. Asignación automática a aulas y secciones en pocos clics.
              </p>
            </div>

            {/* Tarjeta 2: Notas (Esmeralda) */}
            <div className="group bg-white border border-slate-200 border-t-[6px] border-t-emerald-500 p-8 rounded-b-2xl rounded-t-md shadow-md hover:shadow-2xl hover:shadow-emerald-500/10 hover:-translate-y-1 transition-all duration-300">
              <div className="w-14 h-14 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:bg-emerald-600 group-hover:text-white transition-all duration-300">
                <FileSpreadsheet className="h-7 w-7" />
              </div>
              <h4 className="text-xl font-bold text-slate-900 mb-3">Reportes SIAGIE</h4>
              <p className="text-slate-600 leading-relaxed">
                Genera libretas, boletas y plantillas Excel estandarizadas, listas para ser importadas al sistema del Estado Peruano sin errores.
              </p>
            </div>

            {/* Tarjeta 3: Pagos (Ámbar) */}
            <div className="group bg-white border border-slate-200 border-t-[6px] border-t-amber-500 p-8 rounded-b-2xl rounded-t-md shadow-md hover:shadow-2xl hover:shadow-amber-500/10 hover:-translate-y-1 transition-all duration-300">
              <div className="w-14 h-14 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:bg-amber-500 group-hover:text-white transition-all duration-300">
                <DollarSign className="h-7 w-7" />
              </div>
              <h4 className="text-xl font-bold text-slate-900 mb-3">Control de Pagos</h4>
              <p className="text-slate-600 leading-relaxed">
                Gestión centralizada de pensiones, emisión de comprobantes, alertas automáticas de morosidad y arqueo de caja diario.
              </p>
            </div>

            {/* Tarjeta 4: Multi-Institución (Púrpura) */}
            <div className="group bg-white border border-slate-200 border-t-[6px] border-t-purple-500 p-8 rounded-b-2xl rounded-t-md shadow-md hover:shadow-2xl hover:shadow-purple-500/10 hover:-translate-y-1 transition-all duration-300">
              <div className="w-14 h-14 rounded-xl bg-purple-50 text-purple-600 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:bg-purple-600 group-hover:text-white transition-all duration-300">
                <ShieldCheck className="h-7 w-7" />
              </div>
              <h4 className="text-xl font-bold text-slate-900 mb-3">Multi-Institución</h4>
              <p className="text-slate-600 leading-relaxed">
                Administra múltiples colegios, sucursales o empresas desde un único panel super-administrador con bases de datos aisladas.
              </p>
            </div>

            {/* Tarjeta 5: App Docentes (Rosa) */}
            <div className="group bg-white border border-slate-200 border-t-[6px] border-t-rose-500 p-8 rounded-b-2xl rounded-t-md shadow-md hover:shadow-2xl hover:shadow-rose-500/10 hover:-translate-y-1 transition-all duration-300">
              <div className="w-14 h-14 rounded-xl bg-rose-50 text-rose-600 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:bg-rose-500 group-hover:text-white transition-all duration-300">
                <Smartphone className="h-7 w-7" />
              </div>
              <h4 className="text-xl font-bold text-slate-900 mb-3">Portal Docente</h4>
              <p className="text-slate-600 leading-relaxed">
                Los profesores podrán registrar asistencia y subir calificaciones desde cualquier computadora o mediante la aplicación móvil.
              </p>
            </div>

            {/* Tarjeta 6: Gestión de Aulas (Cyan) */}
            <div className="group bg-white border border-slate-200 border-t-[6px] border-t-cyan-500 p-8 rounded-b-2xl rounded-t-md shadow-md hover:shadow-2xl hover:shadow-cyan-500/10 hover:-translate-y-1 transition-all duration-300">
              <div className="w-14 h-14 rounded-xl bg-cyan-50 text-cyan-600 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:bg-cyan-500 group-hover:text-white transition-all duration-300">
                <BookOpen className="h-7 w-7" />
              </div>
              <h4 className="text-xl font-bold text-slate-900 mb-3">Gestión de Aulas</h4>
              <p className="text-slate-600 leading-relaxed">
                Crea y configura aulas, asigna tutores, establece horarios y define la capacidad máxima por sección de manera intuitiva.
              </p>
            </div>

          </div>
        </div>
      </section>
      {/* 4. CALL TO ACTION FINAL Y FOOTER OSCURO */}
      
      {/* CTA Final Integrado */}
      <section className="bg-blue-600 py-16 relative overflow-hidden">
        {/* Patrón de fondo sutil */}
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent"></div>
        
        <div className="max-w-4xl mx-auto px-4 relative text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            ¿Listo para llevar tu institución al siguiente nivel?
          </h2>
          <p className="text-blue-100 text-lg mb-8">
            Únete a las instituciones que ya están optimizando su tiempo y recursos con nuestra plataforma.
          </p>
          <button className="bg-white text-blue-600 px-8 py-4 rounded-xl font-bold text-lg hover:bg-slate-50 shadow-xl transition-all transform hover:-translate-y-1">
            Comenzar mi prueba gratuita
          </button>
        </div>
      </section>

      {/* Footer Principal */}
      <footer id="contacto" className="bg-slate-900 border-t border-slate-800 pt-16 pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            
            {/* Columna 1: Marca */}
            <div className="space-y-4">
              <div className="flex items-center">
                <div className="bg-blue-600 p-1.5 rounded-lg">
                  <BookOpen className="h-5 w-5 text-white" />
                </div>
                <span className="ml-2 text-xl font-black text-white tracking-tight">
                  EMD EduSaaS
                </span>
              </div>
              <p className="text-slate-400 text-sm leading-relaxed">
                Software integral de gestión educativa y empresarial. Simplificando procesos administrativos para que te enfoques en lo que realmente importa: la educación.
              </p>
            </div>

            {/* Columna 2: Enlaces Rápidos */}
            <div>
              <h4 className="text-white font-bold mb-4">Plataforma</h4>
              <ul className="space-y-2 text-sm text-slate-400">
                <li><a href="#caracteristicas" className="hover:text-blue-400 transition-colors">Características</a></li>
                <li><a href="#modulos" className="hover:text-blue-400 transition-colors">Módulos SIAGIE</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">Precios y Planes</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">Actualizaciones</a></li>
              </ul>
            </div>

            {/* Columna 3: Soporte y Legal */}
            <div>
              <h4 className="text-white font-bold mb-4">Soporte</h4>
              <ul className="space-y-2 text-sm text-slate-400">
                <li><a href="#" className="hover:text-blue-400 transition-colors">Centro de Ayuda</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">Tutoriales</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">Términos del Servicio</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">Políticas de Privacidad</a></li>
              </ul>
            </div>

            {/* Columna 4: Contacto */}
            <div>
              <h4 className="text-white font-bold mb-4">Contacto</h4>
              <ul className="space-y-3 text-sm text-slate-400">
                <li className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-blue-500 shrink-0" />
                  <span>Huancayo, Junín<br />Perú</span>
                </li>
                <li className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-blue-500 shrink-0" />
                  <a href="mailto:contacto@emdingenieros.com" className="hover:text-blue-400 transition-colors">
                    contacto@emdingenieros.com
                  </a>
                </li>
                <li className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-blue-500 shrink-0" />
                  <span>+51 (Solicitar número)</span>
                </li>
              </ul>
            </div>
            
          </div>

          {/* Línea divisoria y Copyright */}
          <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm text-center md:text-left">
              &copy; 2026 EMD Ingeniería y Tecnología. Todos los derechos reservados.
            </p>
            <div className="flex gap-4 text-sm text-slate-500">
              <span>www.emdingenieros.com</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;